// The one sign-in page for everyone: candidates (Peoply Kariyer) and companies (HR app).
export const LOGIN_PATH = '/auth/login';

// Where Google/LinkedIn candidate sign-in ends (mirrors the server's CANDIDATE_OAUTH_RESULT_PATH).
export const CANDIDATE_OAUTH_RESULT_PATH = '/auth/oauth';

// The password reset page is shared; a candidate's link carries ?account=candidate (mirrors the
// server's RESET_PASSWORD_* constants).
export const RESET_PASSWORD_ACCOUNT_PARAM = 'account';

export const LOGIN_ACCOUNT_TYPES = {
  candidate: 'candidate',
  employer: 'employer',
} as const;

// Giriş/kayıt sayfalarının sol marka paneli varyantları (auth.showcase.<varyant>): giriş, aday kaydı, firma kaydı.
export const AUTH_SHELL_VARIANTS = {
  login: 'login',
  candidate: 'candidate',
  employer: 'employer',
} as const;
